module.exports = __webpack_public_path__ + "static/media/award4@2x.0cf85dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/award4@2x.png
// module id = 1127
// module chunks = 0